module.exports = __webpack_public_path__ + "static/media/VisbyCF-RegularOblique.5ec96217.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/VisbyCF-RegularOblique.woff
// module id = 796
// module chunks = 0